import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react'

import './styles.scss'

import MicrosoftLogo from '../../../../static/images/microsoft-icon.svg'

type SharedProps = {
  size?: 'sm' | 'lg'
  className?: string
}

export type MicrosoftLoginButtonProps = SharedProps &
  (
    | (Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'size'> & { href?: undefined })
    | (Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'size'> & { href: string })
  )

const MicrosoftLoginButton = ({ size = 'lg', className, ...props }: MicrosoftLoginButtonProps) => {
  const classes = ['microsoft-login-button', `microsoft-login-button--${size}`, className].filter(Boolean).join(' ')
  const content = (
    <div className='d-flex align-items-center'>
      <img src={MicrosoftLogo} className='icon' alt='' />
      <span className='buttonText w-100'>Continue with Microsoft</span>
    </div>
  )

  if ('href' in props && props.href) {
    const { href, ...anchorProps } = props
    return (
      <a href={href} className={classes} {...anchorProps}>
        {content}
      </a>
    )
  }

  const { type = 'button', ...buttonProps } = props as ButtonHTMLAttributes<HTMLButtonElement>
  return (
    <button type={type} className={classes} {...buttonProps}>
      {content}
    </button>
  )
}

export default MicrosoftLoginButton
